function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-plusplus, no-continue, consistent-return */
// Based on https://github.com/One-com/react-truncate
// There are a few minor adjustments to make this component work, mainly around handling exceptions.
// If there are better text truncation options, we should definitely migrate.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var styles = {
  ellipsis: {
    position: 'fixed',
    visibility: 'hidden',
    top: 0,
    left: 0
  }
};

var Truncate =
/*#__PURE__*/
function (_Component) {
  _inherits(Truncate, _Component);

  function Truncate() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Truncate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Truncate)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _this.elements = {};
    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
    _this.onTruncate = _this.onTruncate.bind(_assertThisInitialized(_this));
    _this.calcTargetWidth = _this.calcTargetWidth.bind(_assertThisInitialized(_this));
    _this.measureWidth = _this.measureWidth.bind(_assertThisInitialized(_this));
    _this.getLines = _this.getLines.bind(_assertThisInitialized(_this));
    _this.renderLine = _this.renderLine.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Truncate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var text = this.elements.text,
          calcTargetWidth = this.calcTargetWidth,
          onResize = this.onResize;
      var canvas = document.createElement('canvas');
      this.canvasContext = canvas.getContext('2d');
      calcTargetWidth(function () {
        // Node not needed in document tree to read its content
        if (text && text.parentNode) {
          text.parentNode.removeChild(text);
        }
      });
      window.addEventListener('resize', onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Render was based on outdated refs and needs to be rerun
      if (this.props.children !== prevProps.children) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var ellipsis = this.elements.ellipsis,
          onResize = this.onResize,
          timeout = this.timeout;

      if (ellipsis && ellipsis.parentNode) {
        ellipsis.parentNode.removeChild(ellipsis);
      }

      window.removeEventListener('resize', onResize);

      if (window.cancelAnimationFrame) {
        window.cancelAnimationFrame(timeout);
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.calcTargetWidth();
    }
  }, {
    key: "onTruncate",
    value: function onTruncate(didTruncate) {
      var onTruncate = this.props.onTruncate;

      if (typeof onTruncate === 'function') {
        this.timeout = window.requestAnimationFrame(function () {
          onTruncate(didTruncate);
        });
      }
    }
  }, {
    key: "getLines",
    value: function getLines() {
      var elements = this.elements,
          _this$props = this.props,
          numLines = _this$props.lines,
          ellipsis = _this$props.ellipsis,
          trimWhitespace = _this$props.trimWhitespace,
          targetWidth = this.state.targetWidth,
          innerText = this.innerText,
          measureWidth = this.measureWidth,
          onTruncate = this.onTruncate,
          trimRight = this.trimRight;
      var lines = [];
      var text = innerText(elements.text);
      var textLines = text.split('\n').map(function (line) {
        return line.split(' ');
      });
      var didTruncate = true;
      var ellipsisWidth = this.ellipsisWidth(this.elements.ellipsis);

      for (var line = 1; line <= numLines; line++) {
        var textWords = textLines[0]; // Handle newline

        if (textWords.length === 0) {
          lines.push();
          textLines.shift();
          line--;
          continue;
        }

        var resultLine = textWords.join(' ');

        if (measureWidth(resultLine) <= targetWidth) {
          if (textLines.length === 1) {
            // Line is end of text and fits without truncating
            didTruncate = false;
            lines.push(resultLine);
            break;
          }
        }

        if (line === numLines) {
          // Binary search determining the longest possible line inluding truncate string
          var textRest = textWords.join(' ');
          var lower = 0;
          var upper = textRest.length - 1;

          while (lower <= upper) {
            var middle = Math.floor((lower + upper) / 2);
            var testLine = textRest.slice(0, middle + 1);

            if (measureWidth(testLine) + ellipsisWidth <= targetWidth) {
              lower = middle + 1;
            } else {
              upper = middle - 1;
            }
          }

          var lastLineText = textRest.slice(0, lower);

          if (trimWhitespace) {
            lastLineText = trimRight(lastLineText); // Remove blank lines from the end of text

            while (!lastLineText.length && lines.length) {
              var prevLine = lines.pop();
              lastLineText = trimRight(prevLine);
            }
          }

          resultLine = React.createElement("span", null, lastLineText, ellipsis);
        } else {
          // Binary search determining when the line breaks
          var _lower = 0;

          var _upper = textWords.length - 1;

          while (_lower <= _upper) {
            var _middle = Math.floor((_lower + _upper) / 2);

            var _testLine = textWords.slice(0, _middle + 1).join(' ');

            if (measureWidth(_testLine) <= targetWidth) {
              _lower = _middle + 1;
            } else {
              _upper = _middle - 1;
            }
          } // The first word of this line is too long to fit it


          if (_lower === 0) {
            // Jump to processing of last line
            line = numLines - 1;
            continue;
          }

          resultLine = textWords.slice(0, _lower).join(' ');
          textLines[0].splice(0, _lower);
        }

        lines.push(resultLine);
      }

      onTruncate(didTruncate);
      return lines;
    } // Shim innerText to consistently break lines at <br/> but not at \n

  }, {
    key: "innerText",
    value: function innerText(node) {
      var div = document.createElement('div');
      var contentKey = 'innerText' in window.HTMLElement.prototype ? 'innerText' : 'textContent';
      div.innerHTML = node.innerHTML.replace(/\r\n|\r|\n/g, ' ');
      var text = div[contentKey];
      var test = document.createElement('div');
      test.innerHTML = 'foo<br/>bar';

      if (test[contentKey].replace(/\r\n|\r/g, '\n') !== 'foo\nbar') {
        div.innerHTML = div.innerHTML.replace(/<br.*?[/]?>/gi, '\n');
        text = div[contentKey];
      }

      return text;
    }
  }, {
    key: "calcTargetWidth",
    value: function calcTargetWidth(callback) {
      var target = this.elements.target,
          calcTargetWidth = this.calcTargetWidth,
          canvasContext = this.canvasContext; // Calculation is no longer relevant, since node has been removed

      if (!target) {
        return;
      } // Floor the result to deal with browser subpixel precision


      var elm = target && target.parentNode || target;
      var targetWidth = Math.floor(elm.getBoundingClientRect().width); // Delay calculation until parent node is inserted to the document
      // Mounting order in React is ChildComponent, ParentComponent

      if (!targetWidth) {
        return window.requestAnimationFrame(function () {
          return calcTargetWidth(callback);
        });
      }

      var style = window.getComputedStyle(target);
      var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');
      canvasContext.font = font;
      this.setState({
        targetWidth: targetWidth
      }, callback);
    }
  }, {
    key: "measureWidth",
    value: function measureWidth(text) {
      return this.canvasContext.measureText(text).width;
    }
  }, {
    key: "ellipsisWidth",
    value: function ellipsisWidth(node) {
      return node.offsetWidth;
    }
  }, {
    key: "trimRight",
    value: function trimRight(text) {
      return text.replace(/\s+$/, '');
    }
  }, {
    key: "renderLine",
    value: function renderLine(line, i, arr) {
      if (i === arr.length - 1) {
        return React.createElement("span", {
          key: i
        }, line);
      } else {
        var br = React.createElement("br", {
          key: i + 'br'
        });

        if (line) {
          return [React.createElement("span", {
            key: i
          }, line), br];
        } else {
          return br;
        }
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;

      var _this$props2 = this.props,
          tag = _this$props2.tag,
          children = _this$props2.children;
      var ChildrenWrapperTag = tag;
      return React.createElement(ChildrenWrapperTag, {
        ref: function ref(textEl) {
          _this2.elements.text = textEl;
        }
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var target = this.elements.target,
          _this$props3 = this.props,
          children = _this$props3.children,
          ellipsis = _this$props3.ellipsis,
          lines = _this$props3.lines,
          spanProps = _objectWithoutProperties(_this$props3, ["children", "ellipsis", "lines"]),
          targetWidth = this.state.targetWidth,
          getLines = this.getLines,
          renderLine = this.renderLine,
          onTruncate = this.onTruncate;

      var text;
      var mounted = !!(target && targetWidth);

      if (typeof window !== 'undefined' && mounted) {
        if (lines > 0) {
          text = getLines().map(renderLine);
        } else {
          text = children;
          onTruncate(false);
        }
      }

      delete spanProps.onTruncate;
      delete spanProps.trimWhitespace;
      delete spanProps.tag;
      return React.createElement("span", _extends({}, spanProps, {
        ref: function ref(targetEl) {
          _this3.elements.target = targetEl;
        }
      }), React.createElement("span", null, text), this.renderChildren(), React.createElement("span", {
        ref: function ref(ellipsisEl) {
          _this3.elements.ellipsis = ellipsisEl;
        },
        style: styles.ellipsis
      }, ellipsis));
    }
  }]);

  return Truncate;
}(Component);

_defineProperty(Truncate, "propTypes", {
  tag: PropTypes.string,
  children: PropTypes.node,
  ellipsis: PropTypes.node,
  lines: PropTypes.oneOfType([PropTypes.oneOf([false]), PropTypes.number]),
  trimWhitespace: PropTypes.bool,
  onTruncate: PropTypes.func
});

_defineProperty(Truncate, "defaultProps", {
  tag: 'span',
  children: '',
  ellipsis: '…',
  lines: 1,
  trimWhitespace: false
});

export { Truncate as default };